export default class NullEvent {
  bindEvents(){ }
}
